<h5 style="color:#020202; background:#d3e1e7;" class="px-3 mt-2"><b>{{ 'INCUMBENCY_FIELD_OFFICERS' | translate }}</b></h5>

<div class="card dashboardTable">

    <p-table #officerTable [value]="officesList" [paginator]="false" showGridlines stripedRows
        [globalFilterFields]="[
        'sNo',
		'officeName',
		'designation',
		'contact_landLine',
		'contact_mobile',
		'email_address',
        ]" responsiveLayout="stack" [breakpoint]="'600px'" 
        [tableStyle]="{ 'min-width': '100%' }" [showCurrentPageReport]="false">
      
        <ng-template  #header pTemplate="header">
            <tr>
                <th pSortableColumn="sNo">{{'S_NO'| translate}}</th>
                <th>{{'OFFICER_NAME'| translate}}</th>
                <th>{{'DESIGNATION'| translate}}</th>
                <th>{{'CONTACT_NO(LANDLINE)'| translate}}</th>
                <th>{{'CONTACT_NO(MOBILE)'| translate}}</th>
                <th>{{'EMAIL_ADDRESS'| translate}}</th>
            </tr>
        </ng-template>
        <ng-template #body pTemplate="body" let-product>
            <tr>
                <td>{{ product.sNo }}</td>
                <td>{{ product.officeName }}</td>
                <td>{{ product.designation }}</td>
                <td>{{ product.contact_landLine }}</td>
                <td>{{ product.contact_mobile }}</td>
                <td>{{ product.email_address }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- <div class="card dashboardTable">
    <p-table
        [value]="officesList"
        showGridlines
        stripedRows
        responsiveLayout="stack"
        [breakpoint]="'960px'" 
        [tableStyle]="{'min-width': '50rem'}">
            <ng-template #header>
                <tr>
                    <th>{{ 'S_NO' | translate}}</th>
                    <th>{{ 'OFFICER_NAME' | translate }}</th>
                    <th>{{ 'DESIGNATION' | translate }}</th>
                    <th>{{ 'CONTACT_NO(LANDLINE)' | translate }}</th>
                    <th>{{ 'CONTACT_NO(MOBILE)' | translate }}</th>
                    <th>{{ 'EMAIL_ADDRESS' | translate }}</th>
                </tr>
            </ng-template>
            <ng-template #body let-product>
                <tr>
                    <td>{{ product.sNo }}</td>
                    <td>{{ product.officeName }}</td>
                    <td>{{ product.designation }}</td>
                    <td>{{ product.contact_landLine }}</td>
                    <td>{{ product.contact_mobile }}</td>
                    <td>{{ product.email_address }}</td>
                </tr>
            </ng-template>
    </p-table>
</div> -->

<!-- <table class="w3-border" style="border-collapse:separate; margin-left:40px; width:90%;">
  <tr>
    <th>{{ }}</th>
    <th>Officer's</th>
    <th>Designation</th>
    <th>Telephone No.</th>
  </tr>
  <tr>
    <td>1</td>
    <td>Head Office, MICADA, Haryana</td>
    <td>Officer on Special Duty </td>
    <td>0172 2567034 </td>
  </tr>
  <tr>
    <td>2</td>
    <td>MICAD Circle Rohtak</td>
    <td>Superintending Engineer (SPIO)</td>
    <td>01262-256006</td>
  </tr>
  <tr>
    <td>3</td>
    <td>MICAD Circle Kaithal</td>
    <td>Superintending Engineer (SPIO)</td>
    <td>01746- 222028</td>
  </tr>
  <tr>
    <td>4</td>
    <td>MICAD Circle Hisar</td>
    <td>Superintending Engineer (SPIO)</td>
    <td>01662-227369</td>
  </tr>
  <tr>
    <td>5</td>
    <td>MICAD Division Rohtak</td>
    <td>Executive Engineer(SPIO)</td>
    <td>01262-254552</td>
  </tr>
  <tr>
    <td>6</td>
    <td>MICAD Division Jhajjar</td>
    <td>Executive Engineer(SPIO)</td>
    <td>01251-257076</td>
  </tr>
  <tr>
    <td>7</td>
    <td>MICAD Division Jind</td>
    <td>Executive Engineer(SPIO)</td>
    <td>01681-227072</td>
  </tr>
  <tr>
    <td>8</td>
    <td>MICAD Division Rewari</td>
    <td>Executive Engineer(SPIO)</td>
    <td>01274-260404</td>
  </tr>
  <tr>
    <td>9</td>
    <td>MICAD Division Kaithal</td>
    <td>Executive Engineer(SPIO)</td>
    <td>01746-224337</td>
  </tr>
  <tr>
    <td>10</td>
    <td>MICAD Division Karnal</td>
    <td>Executive Engineer(SPIO)</td>
    <td>0184-2271054</td>
  </tr>
  <tr>
    <td>11</td>
    <td>MICAD Division Kurukshetra</td>
    <td>Executive Engineer(SPIO)</td>
    <td>01744-238740</td>
  </tr>
  <tr>
    <td>12</td>
    <td>MICAD Division Panipat</td>
    <td>Executive Engineer(SPIO)</td>
    <td>0180-2650805</td>
  </tr>
  <tr>
    <td>13</td>
    <td>MICAD Division Hisar</td>
    <td>Executive Engineer(SPIO)</td>
    <td>01662-235425</td>
  </tr>
  <tr>
    <td>14</td>
    <td>MICAD Division Bhiwani</td>
    <td>Executive Engineer(SPIO)</td>
    <td>01664-244273</td>
  </tr>
  <tr>
    <td>15</td>
    <td>MICAD Division Fatehabad</td>
    <td>Executive Engineer(SPIO)</td>
    <td>01667-227125</td>
  </tr>
  <tr>
    <td>16</td>
    <td>MICAD Division Sirsa</td>
    <td>Executive Engineer(SPIO)</td>
    <td>01666-244129</td>
  </tr>

</table><br> -->